var initializeTextFlexible = function () {
    document.querySelectorAll(".c-text-flexible__text-teaser-link").forEach(function (item) {
        var scrollPosition = null;
        item.addEventListener('click', function (e) {
            e.preventDefault();
            var target = e.currentTarget;
            var element = target.parentElement.querySelector('.c-text-flexible__text');
            if (element.classList.contains('c-text-flexible__text--truncated')) {
                scrollPosition = window.scrollY;
                element.classList.remove('c-text-flexible__text--truncated');
                target.innerHTML = target.getAttribute('data-less');
            }
            else {
                element.classList.add('c-text-flexible__text--truncated');
                target.innerHTML = target.getAttribute('data-more');
                window.scrollTo(0, scrollPosition);
            }
        });
    });
};
export default initializeTextFlexible;
